import z from "zod";
import { StripUnderscore, UnderscoreKeys } from "../util/Types";
import { OrderItemUI, OrderItemUIFields } from "./OrderItemUI";
import { OrderItemStatus } from "./Enums";

//Intentionally separate from UI schema (instead rejoin Fields into type)
export const orderItemDbSchema = z.object({
	_paymentSessionId: z.string().optional()
}).passthrough();
export const orderItemDbPaidSchema = orderItemDbSchema.extend({
	_paymentSessionId: z.string()
})
export type OrderItemDbFields = OrderItemUIFields & StripUnderscore<z.infer<typeof orderItemDbSchema>>;

export class OrderItemDb<TFields extends OrderItemDbFields = OrderItemDbFields> extends OrderItemUI<TFields> {
	private _paymentSessionId?: string | undefined;
	override _className: string = "OrderItem";
	override _deserializeClassName: string = "OrderItemDb";

	constructor(props: Partial<TFields>) {
		super(props);
	}
	override getFieldList(): (keyof UnderscoreKeys<TFields>)[] {
		return [...super.getFieldList(), "_paymentSessionId"];
	}
	override validateSchema(): void {
		//Need to call super as schemas don't extend from previous object
		super.validateSchema();
		switch(this.status){
			case OrderItemStatus.PAID:
			case OrderItemStatus.PROCESSED:
				orderItemDbPaidSchema.parse(this);
				return;
			case OrderItemStatus.CREATED:
			default:
				orderItemDbSchema.parse(this);
				return;
		}
	}
	get paymentSessionId(): string | undefined {
		return this.checkFieldType<"paymentSessionId">(this._paymentSessionId);
	}
	set paymentSessionId(value: string | undefined) {
		this._paymentSessionId = this.checkFieldTypeAndMark<"paymentSessionId">("_paymentSessionId", value);
	}
}
